import { ChatBot, ChatUser } from 'components/chat';
import React from 'react';

const MessageDisplay = ({ message, isCandidate }: { message: any; isCandidate?: boolean }) => {
  return (
    <>
      {message.sender === 'system' ? (
        (typeof message.content === 'string' && !message.content.includes('{')) && <ChatBot message={message} />
      ) : (
        <ChatUser message={message} isCandidate={isCandidate} />
      )}
    </>
  );
};

export { MessageDisplay };